import { render, staticRenderFns } from "./register_forms.vue?vue&type=template&id=0443d73c&scoped=true&"
import script from "./register_forms.vue?vue&type=script&lang=js&"
export * from "./register_forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0443d73c",
  null
  
)

export default component.exports